import { useEffect, useMemo, useState } from "react";
import api from "../lib/api";
import { Mail } from "lucide-react";

const TIER_ORDER = ["Main Sponsor", "Technical Partner", "Official Partner", "Official Medical Partner"];

export default function Partner() {
  const [partners, setPartners] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/partners").then((r) => setPartners(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const grouped = useMemo(() => {
    const map = {};
    TIER_ORDER.forEach((t) => (map[t] = []));
    partners.forEach((p) => {
      if (!map[p.tier]) map[p.tier] = [];
      map[p.tier].push(p);
    });
    return map;
  }, [partners]);

  return (
    <main className="max-w-7xl mx-auto px-4 sm:px-6 py-20" data-testid="partner-page">
      <p className="font-mono text-xs sm:text-sm tracking-[0.3em] uppercase text-gold mb-4">Insieme, più forti</p>
      <h1 className="font-display font-black uppercase text-6xl sm:text-8xl lg:text-9xl text-white leading-[0.85] tracking-tighter mb-16" data-testid="partner-title">
        I Nostri <span className="text-gold">Partner</span>
      </h1>

      {loading && <p className="text-zinc-400 font-mono text-sm" data-testid="partner-loading">Caricamento partner...</p>}

      {Object.entries(grouped).map(([tier, list]) =>
        list.length > 0 ? (
          <section key={tier} className="mb-14" data-testid={`partner-tier-${tier.toLowerCase().replace(/\s/g, "-")}`}>
            <div className="flex items-center gap-4 mb-7">
              <span className="h-1 w-12 bg-gold" />
              <h2 className="font-display font-black uppercase text-4xl sm:text-5xl text-white leading-none">{tier}</h2>
            </div>
            <div>
              {list.map((p) => (
                <div
                  key={p.id}
                  data-testid={`partner-card-${p.id}`}
                  className="flex flex-col sm:flex-row sm:items-center gap-6 sm:gap-12 py-10 border-b border-line last:border-b-0"
                >
                  <div className="sm:w-80 shrink-0 flex items-center justify-center gap-4">
                    <img src={p.logo} alt={`Logo ${p.name}`} className="max-h-28 sm:max-h-32 w-auto max-w-[220px] object-contain rounded" />
                    {p.logo2 && <img src={p.logo2} alt={`Logo secondario ${p.name}`} className="max-h-10 w-auto max-w-[80px] object-contain rounded opacity-90" />}
                  </div>
                  <div className="hidden sm:block w-1 self-stretch bg-gold shrink-0" />
                  <div className="sm:hidden h-1 w-24 bg-gold" />
                  <div>
                    <h3 className="font-display font-black uppercase text-4xl sm:text-6xl text-white leading-none tracking-[0.02em]">{p.name}</h3>
                    {p.description && <p className="text-zinc-400 mt-3">{p.description}</p>}
                  </div>
                </div>
              ))}
            </div>
          </section>
        ) : null
      )}

      <section className="mt-20 bg-gold text-night p-10 sm:p-14" data-testid="partner-cta">
        <h2 className="font-display font-black uppercase text-4xl sm:text-6xl leading-none">
          Diventa Partner<br />dell'Artemide FC
        </h2>
        <p className="mt-4 max-w-2xl font-medium">
          Visibilità allo stadio, sulle maglie e sui canali del club. Unisciti alla famiglia nero-gialla
          e fai crescere la tua attività insieme a noi.
        </p>
        <a
          href="mailto:artemidefc@gmail.com"
          data-testid="partner-cta-button"
          className="mt-8 inline-flex items-center gap-3 bg-night text-gold font-display uppercase tracking-wider font-bold text-xl px-8 py-4 hover:bg-surface transition-colors"
        >
          <Mail size={20} /> artemidefc@gmail.com
        </a>
      </section>
    </main>
  );
}
